"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "parre": {
    "69fe17b7": [{
      "hkey": "7247453f",
      "slug": "parre",
      "name": "Parre",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-selva": [{
      "hkey": "7247453f",
      "slug": "parre",
      "name": "Parre",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "104273fd": [{
      "hkey": "9551d1b2",
      "slug": "sant-alberto-grumella",
      "name": "Sant'Alberto-Grumella",
      "primary": true,
      "skipSearch": false
    }],
    "sant-alberto": [{
      "hkey": "9551d1b2",
      "slug": "sant-alberto-grumella",
      "name": "Sant'Alberto-Grumella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;